import { render, staticRenderFns } from "./DebtorList.vue?vue&type=template&id=5759c73c&scoped=true"
import script from "./DebtorList.vue?vue&type=script&lang=js"
export * from "./DebtorList.vue?vue&type=script&lang=js"
import style0 from "./DebtorList.vue?vue&type=style&index=0&id=5759c73c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5759c73c",
  null
  
)

export default component.exports